export default ($http) => ({
  fetchHeaderMenu () {
    return $http.get('header-menu')
  },
  fetchGoogleCalendarAccounts () {
    return $http.get('google-calendar-accounts')
  },
  fetchGoogleAccount (accountId) {
    return $http.get(`google-calendar-accounts/${accountId}`)
  },
  deleteGoogleAccount (accountId) {
    return $http.delete(`google-calendar-accounts/${accountId}`)
  },
  updateGoogleCalendar (accountId, items) {
    return $http.post(`google-calendar-export/${accountId}`, { body: { curriculumMaps: items } })
  },
  publicLogin (password) {
    return $http.post('login', { body: { password } })
  },
  getComplexChecklistData () {
    return $http.get('complex-checklist')
  }
})
